import orderBy from "lodash/orderBy";
import { trackEventConstant } from "../../plugins/analytics.constant";

export const communityDirectoryPageConstant = {
    label: {
        COMMUNITY_DIRECTORY_TITLE: 'Community Directory',
        SELECT_CATEGORIES_TITLE: 'Select one or more categories to refine your results',
        SORT_BY: 'Sort by ',
        DIRECTORY_TEXT_LENGTH: 80,
        MORE: 'More >',
        BACK: '< Back',
        CLEAR_ALL: 'Clear All',
        NO_RESULT_FOUND: 'Sorry no members found',
        DEFAULT_TYPE_AHEAD_LABEL: 'WHAT ARE YOU INTERESTED TO SEE?',
        DEFAULT_SUB_FILTER_LABEL: 'PLEASE SELECT ONE OR MORE OPTIONS FROM FOLLOWING',
        NO_TYPE_AHEAD_RESULT_FOUND: 'No results found',
        PRIVATE: 'Private',
        PARTICIPANTS: 'Participants',
        MEMBERS_ONLY: 'Members Only',
        SECONDARY_FILTER_LABEL_DEFAULT: 'PLEASE SELECT ONE OR MORE FROM FOLLOWING?',
        VIEW_FULL_COMMUNITY_DIRECTORY: 'view the full Community Directory',
    },
    constant: {
        maxIndexForRibbonFilter: 9,
        searchResultOffsetStep: 50,
        searchResultMaxCount: 50,
        minimumCountForRolodex: 10,
        communitypagevtrackarray: [
            trackEventConstant.COMPONENT.COMMUNITY_DIRECTORY_SEARCH_PAGE,
            trackEventConstant.ENTITY.ROLODEX,
            trackEventConstant.ACTION.FILTER_COMMUNITIES_BY_LETTER,
        ],
    },
};

export const sortOptions = [
    {
        label: 'Community Name',
        key: 'communityName_asc',
        sortField: 'CommunityName',
        direction: 'asc',
    },
];
export const defaultSort = sortOptions[0];

export const defaultCommunityFilters = {
    CommunityType: [
        {
            label: 'Group',
            filterKey: 'CommunityType',
            filterValue: 'Group',
            isTypeAhead: false,
            subFilters: [],
            count: 1,
            ribbonGroupName: 'Community Type',
            isDropdown: false,
        },
    ],
    CommunityFocus: [],
    EligibilityRequirements: [],
};
export const ribbonTitles = [
    {
        name: 'Community Type',
        key: 'CommunityType',
        component: 'CommunityType',
        label: 'ARE YOU LOOKING FOR SPECIFIC COMMUNITIES?',
    },
    {
        name: 'Focus',
        key: 'CommunityFocus',
        component: 'Focus',
        label: 'WHICH BEST DESCRIBE THE COMMUNITIES YOU ARE LOOKING FOR?',
    },
    {
        name: 'Who Can Participate',
        key: 'EligibilityRequirements',
        component: 'WhoCanParticipate',
        label: 'REFINE YOUR RESULTS BY TYPES OF MEMBERS IN THE COMMUNITY.',
    },
];

export const subFiltersForRibbon = [
    {
        key: 'CommunityFocus',
        label: 'WHAT SPECIFIC TYPES OF COMMUNITIES APPEAL TO YOU?',
    },
];

export const createCommunityState = () => {
    const state = {};
    if (ribbonTitles && ribbonTitles.length > 0) {
        ribbonTitles.forEach((item) => {
            state[item.key] = [];
        });
    }
    return state;
};
